import React from "react";
import moment from 'moment';

export const HackerColumnFormatter = (cellContent, row, rowIndex, dIndexName) => (
  row.isHacker ? 'Yes' : 'No'
  
);
